<template>
  <div class="card" :class="{ 'bd-0': hideBorder }">
    <div class="card-header pd-x-10-f tx-medium" v-if="points.rdy">
      <div v-if="isLicensedMembers()">
        <div class="d-flex align-items-center">
          Лиценз
          <div
            v-if="licenseUnlimit"
            class="mg-l-auto badge badge-primary text-uppercase pd-t-5 tx-11"
          >
            ХЯЗГААРГҮЙ
          </div>
          <div v-else class="mg-l-auto">
            {{ points.obj.d1 | moment("YY.MM.DD") }} -
            {{ points.obj.d2 | moment("YY.MM.DD") }}
          </div>
        </div>
        <div
          class="tx-color-03 tx-11 text-uppercase mg-t-5"
          v-if="!licenseUnlimit"
        >
          <div class="progress ht-4 op-7 mg-b-5">
            <div
              class="progress-bar bg-success"
              :style="`width: ${100 - points.obj.perc}% !important`"
            ></div>
          </div>
          <div class="d-flex align-items-center">
            Хугацаа дуусахад
            <div class="mg-l-auto">
              {{ points.obj.remainDays.toFixed(0, 10) }}
              <sup>хоног</sup>
            </div>
          </div>
        </div>
      </div>
      <div v-else>Үүргийн биелэлт</div>
    </div>
    <div class="card-body pd-0-f" v-if="points.rdy">
      <!-- <div v-for="(p,i) in points.obj.pointOptions" :key="i">{{p.name}}</div> -->
      <div
        @click="pointInfo(p)"
        :class="`media pd-x-10 pd-y-0 mg-t-20`"
        v-for="(p, i) in points.obj.pointOptions"
        :key="i"
        role="button"
      >
        <div class="media-body">
          <div class="d-flex align-items-center">
            <!-- <feather type="info" class="ht-20-f wd-20-f"></feather> -->
            <h6 class="tx-13 mg-b-2">
              {{ p.name }} ?
              <span class="tx-color-03 tx-normal tx-11"
                >/{{ ((p.point * 100) / p.maxPoint).toFixed(0) }}%/</span
              >
            </h6>
            <strong class="tx-medium mg-l-auto">{{ p.point }}</strong>
          </div>
          <div class="progress ht-4 op-7 mg-b-5">
            <div
              class="progress-bar bg-gray-500"
              :style="
                `width: ${((p.point * 100) / p.maxPoint).toFixed(
                  0
                )}% !important`
              "
            ></div>
          </div>
          <div class="d-flex justify-content-between tx-12">
            <span class="tx-color-03">Боломжит оноо</span>
            <span class="tx-color-03 mg-l-auto">{{ p.maxPoint }}</span>
          </div>
        </div>
      </div>
      <div class="media pd-x-10 pd-y-10 mg-t-20 bd-t bg-light">
        <div class="media-body">
          <div class="d-flex">
            <h6 class="tx-13 mg-b-2">Нийт оноо</h6>
            <strong class="mg-l-auto tx-medium">{{
              points.obj.pointOptions.reduce(
                (sum, st) => sum + parseInt(st.point),
                0
              )
            }}</strong>
          </div>
          <div class="progress ht-4 op-7">
            <div
              class="progress-bar"
              :style="
                `width: ${(
                  (points.obj.pointOptions.reduce(
                    (sum, st) => sum + parseInt(st.point),
                    0
                  ) *
                    100) /
                  points.obj.pointOptions.reduce(
                    (sum, st) => sum + parseInt(st.maxPoint),
                    0
                  )
                ).toFixed(0)}% !important`
              "
            ></div>
          </div>
          <div class="d-flex justify-content-between tx-12">
            <span class="tx-color-03">Боломжит оноо</span>
            <span class="tx-color-03 mg-l-auto">{{
              points.obj.pointOptions.reduce(
                (sum, st) => sum + parseInt(st.maxPoint),
                0
              )
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card-footer pd-5-f"
      v-if="
        ($store.state.app.activeGroup.id == 9157 ||
          $store.state.app.activeGroup.id == 6126) &&
          !hidePrint
      "
    >
      <div class="d-flex align-items-center mg-b-5">
        <div>Он</div>
        <div class="mg-l-auto">
          <Select @change="yrChanged" v-model="yrsCur" size="mini">
            <Option
              v-for="(yr, i) in yrs"
              :key="i"
              :value="yr"
              :label="yr"
            ></Option>
          </Select>
        </div>
      </div>

      <button
        @click="printMission()"
        class="btn btn-xs btn-block btn-success btn-uppercase"
      >
        <feather type="printer" class="mg-r-5"></feather>
        <span v-if="$store.state.app.activeGroup.id == 6126"
          >Ёс зүйн тодорхойлолт хэвлэх</span
        >
        <span v-else>Үүргийн биелэлт хэвлэх</span
        ><!--  -->
      </button>
    </div>

    <b-modal v-model="pntInf.modal" :title="pntInf.obj.name" hide-footer>
      <div v-html="pntInf.obj.info"></div>
    </b-modal>
  </div>
</template>

<script>
import { hasOneOf } from "@/libs/tools";
import { request } from "@/api/all";
import { MessageBox, Select, Option } from "element-ui";
import { localSave, localRead } from "@/libs/util";
import Cookies from "js-cookie";
const moment = require("moment");

export default {
  components: {
    MessageBox,
    Select,
    Option
  },
  props: {
    hideBorder: {
      type: Boolean,
      default: () => false
    },
    hidePrint: {
      type: Boolean,
      default: () => false
    },
    userId: {
      type: String,
      default: () => ""
    },
    userTaskId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      licenseHas: true,
      licenseUnlimit: false,
      alert: {
        minDays: 180,
        leftDays: 0,
        expireDays: 14,
        show: false,
        msg: ""
      },
      points: {
        obj: {
          pointOptions: []
        },
        rdy: false
      },
      pntInf: {
        obj: {},
        modal: false
      },
      yrs: [],
      yrsCur: new Date().getFullYear()
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    yrChanged(e) {
      // console.log('e', e);
      this.init();
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    init() {
      let self= this;
      this.points.obj = {pointOptions:[]};
      this.points.rdy = false;
      request({
        api: { method: "GET", url: "learn/GetMyTMZPoint" },
        params: { 
          selectedUserId: this.userId,
          year: this.yrsCur
        },
        store: this.$store
      }).then(res => {
        if (res != false) {
          //console.log(res);

          this.points.obj = res.data;
          this.points.rdy = true;

          if (this.points.obj.d1 != null && this.points.obj.d2 != null) {
            var today = moment(this.points.obj.d2);
            var due = moment(this.points.obj.d1);
            this.licenseUnlimit = today.diff(due, "year") >= 50;
            this.alert.leftDays = this.points.obj.remainDays;
            if (
              this.alert.leftDays < this.alert.minDays &&
              this.$store.state.app.activeGroup.id == 6126
            ) {
              this.alert.show = true;
              this.alert.msg =
                "Таны ТМЗ эрхийн хугацаа дуусахад " +
                this.alert.leftDays.toFixed(0, 10) +
                " хоног үлдсэн байна. Эрх сунгах сургалтандаа хамрагдана уу.  Холбоо барих Утас: 76118989 И-мэйл: education@cpta.mn";

              if (!Cookies.get("license-alert-show")) this.showLicenseAlert();
            }
          } else {
            this.licenseHas = false;
          }
        } else {
          this.licenseHas = false;
        }
      });

      this.yrs = [];
      // this.yrs.push(2020);
      // this.yrs.push(2021);
      // this.yrs.push(2022);
      const currentYear = new Date().getFullYear();
      for (let year = 2020; year <= currentYear; year++) {
        // console.log('year', year);
          self.yrs.push(year); // Add each year to the array
      }
      // //new Date().getFullYear()
      // for(let a = 0; a < 10; a++ ){
      //   console.log(a);
      //   this.yrs.push(i);
      // }
    },
    showLicenseAlert() {
      MessageBox.alert(this.alert.msg, "Мэдэгдэл", {
        confirmButtonText:
          "Дахиж " + this.alert.expireDays + " хоног харуулахгүй",
        callback: action => {
          //console.log(action);
          if (action == "cancel") localSave("license-alert-show", 1);
          else if (action == "confirm")
            Cookies.set("license-alert-show", 1, {
              expires: this.alert.expireDays
            });
        }
      });
    },
    isLicensedMembers() {
      return (
        this.licenseHas &&
        hasOneOf([6126, 9157, 9161], [this.$store.state.app.activeGroup.id])
      );
    },
    printMission() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "member/GetDefinitionOfPerformanceData" },
        data: { id: this.userTaskId, year: this.yrsCur },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          window.open(res.data.link, "_blank");
        }
      });
    },
    pointInfo(p) {
      this.pntInf.obj = p;
      this.pntInf.modal = true;
    }
  }
};
</script>
